import { useDispatch } from 'react-redux'

/**
 * Custom hook for typed dispatch
 * @returns {import('@/store').AppDispatch} Typed dispatch function
 * @example
 * const dispatch = useAppDispatch()
 * dispatch(setUser(userData))
 */
export const useAppDispatch = () => useDispatch()
